import React from 'react';
import ReactStickyNotes from '@react-latest-ui/react-sticky-notes';
function Ideate() {
    return (
        <ReactStickyNotes />
    )
}

export default Ideate
